import type { DatadogConfig } from '@vaad1st/datadog-config';

type DatadogEnvironment = Readonly<Record<string, string | undefined>>;

const configuredValue = (value: string | undefined) => {
  const normalizedValue = value?.trim();

  return normalizedValue && normalizedValue.toUpperCase() !== 'BLANK'
    ? normalizedValue
    : undefined;
};

const datadogEnvironmentName = (environmentName: string | undefined) => {
  if (environmentName === 'grn') return 'production';

  return environmentName || 'local';
};

/** Builds Browse's app-specific values over the shared Datadog defaults. */
export function createDatadogBrowserConfig(
  environment: DatadogEnvironment,
  plugins: NonNullable<DatadogConfig['plugins']>,
): DatadogConfig {
  const applicationId = configuredValue(
    environment.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
  );
  const clientToken = configuredValue(
    environment.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  );

  return {
    applicationId,
    clientToken,
    enabled:
      environment.NEXT_PUBLIC_DATADOG_ENABLED?.toLowerCase() === 'true' &&
      environment.NEXT_PUBLIC_AEM_MODE !== 'preview' &&
      Boolean(applicationId && clientToken),
    env: datadogEnvironmentName(
      configuredValue(environment.NEXT_PUBLIC_ENVIRONMENT_NAME),
    ),
    plugins,
    service: 'browse-nextjs',
    site: configuredValue(environment.NEXT_PUBLIC_DATADOG_SITE),
    version: configuredValue(environment.NEXT_PUBLIC_DATADOG_VERSION),
  };
}
